import { MessageCircle, Plus, Bell, BellOff } from 'lucide-react';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';
import { ConversationItem } from './ConversationItem';

export function ConversationList({
  conversations,
  selectedConversation,
  currentUserId,
  isDark,
  loading,
  mobileView,
  pushSupported,
  pushSubscribed,
  pushLoading,
  onSelectConversation,
  onNewConversation,
  onToggleNotifications,
  onTogglePin,
  onToggleMute,
  formatTime
}) {
  return (
    <div className={cn(
      'flex flex-col border-r',
      isDark ? 'border-white/10' : 'border-gray-200',
      mobileView === 'chat' ? 'hidden md:flex' : 'flex',
      'w-full md:w-80 lg:w-96'
    )}>
      {/* Header */}
      <div className={cn(
        'p-4 border-b flex items-center justify-between',
        isDark ? 'border-white/10' : 'border-gray-200'
      )}>
        <h2 className={cn('text-lg font-bold', isDark ? 'text-white' : 'text-gray-900')}>
          Messages
        </h2>
        <div className="flex items-center gap-2">
          {/* Notification toggle button */}
          {pushSupported && (
            <Button
              size="sm"
              variant="ghost"
              onClick={onToggleNotifications}
              disabled={pushLoading}
              className={cn(
                'p-2',
                pushSubscribed ? 'text-green-500' : (isDark ? 'text-zinc-400' : 'text-gray-500')
              )}
              title={pushSubscribed ? 'Désactiver les notifications' : 'Activer les notifications'}
              data-testid="notification-toggle-btn"
            >
              {pushLoading ? (
                <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
              ) : pushSubscribed ? (
                <Bell size={18} />
              ) : (
                <BellOff size={18} />
              )}
            </Button>
          )}
          <Button
            size="sm"
            onClick={onNewConversation}
            className="bg-red-500 hover:bg-red-600 text-white"
            data-testid="new-conversation-btn"
          >
            <Plus size={18} />
          </Button>
        </div>
      </div>
      
      {/* Conversations */}
      <div className="flex-1 overflow-y-auto">
        {loading ? (
          <div className="p-4 text-center">
            <div className="animate-spin w-8 h-8 border-2 border-red-500 border-t-transparent rounded-full mx-auto"></div>
          </div>
        ) : conversations.length === 0 ? (
          <div className="p-8 text-center">
            <MessageCircle size={48} className={cn('mx-auto mb-4', isDark ? 'text-zinc-600' : 'text-gray-400')} />
            <p className={isDark ? 'text-zinc-500' : 'text-gray-500'}>Aucune conversation</p>
            <Button
              size="sm"
              onClick={onNewConversation}
              className="mt-4 bg-red-500 hover:bg-red-600 text-white"
            >
              Démarrer une conversation
            </Button>
          </div>
        ) : (
          conversations.map((conv) => (
            <ConversationItem
              key={conv.id}
              conversation={conv}
              isSelected={selectedConversation?.id === conv.id}
              currentUserId={currentUserId}
              isDark={isDark}
              onSelect={() => onSelectConversation(conv)}
              onTogglePin={(e) => onTogglePin(conv.id, conv.is_pinned, e)}
              onToggleMute={(e) => onToggleMute(conv.id, conv.is_muted, e)}
              formatTime={formatTime}
            />
          ))
        )}
      </div>
    </div>
  );
}
